"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const React = __importStar(require("react"));
const Spacer_1 = __importDefault(require("../Spacer/Spacer"));
const CreditCard = ({ issuer, lastDigits, holderLabel, holder, expires, expiresLabel, disabled, }) => {
    const expiresDate = moment_1.default(expires);
    const expired = expiresDate.isBefore(moment_1.default(), 'day');
    const issuerClass = `card-provider-${getIssuerString(issuer)}`;
    const isDisabled = disabled || expired;
    const creditCardClass = `credit-card ${isDisabled && 'disabled'}`;
    return (React.createElement("div", { className: "credit-card-container" },
        isDisabled && React.createElement("div", { className: "strike-through" }),
        React.createElement("div", { className: creditCardClass },
            React.createElement(Spacer_1.default, { size: "lg" }),
            React.createElement("div", { className: "card-nr" },
                "**** **** **** ",
                lastDigits),
            React.createElement("div", { className: "clearfix" },
                React.createElement("div", { className: "card-details card-exp" },
                    React.createElement("span", null, expiresLabel),
                    React.createElement("br", null),
                    expiresDate.format('MM/YY')),
                React.createElement(Spacer_1.default, { size: "sm" }),
                React.createElement("div", { className: issuerClass })))));
};
CreditCard.defaultProps = {
    expiresLabel: 'Expires',
    holderLabel: 'Card holder',
};
exports.default = CreditCard;
function getIssuerString(issuer) {
    const lower = issuer.toLowerCase();
    if (lower.includes('visa')) {
        return 'visa';
    }
    else if (lower.includes('mastercard')) {
        return 'mastercard';
    }
    else if (lower.includes('maestro')) {
        return 'maestro';
    }
    else if (lower.includes('discover')) {
        return 'discover';
    }
    else if (lower.includes('diners')) {
        return 'diners';
    }
    else if (issuer.includes('MC')) {
        return 'mastercard';
    }
    return '';
}
//# sourceMappingURL=CreditCard.js.map